export default __webpack_public_path__ + "static/media/052-motorway.84800887.png";